module.exports = __webpack_public_path__ + "img/library-publications.fc2e6c2f.png";